import { Checkbox, CheckboxProps } from '@mantine/core'

interface TermsAndPrivacyCheckboxProps extends Omit<CheckboxProps, 'label'> {
  // Allow spreading form.getInputProps('termsAccepted', { type: 'checkbox' })
}

const TermsAndPrivacyCheckbox = (props: TermsAndPrivacyCheckboxProps) => {
  return (
    <Checkbox
      label={
        <>
          I accept the{' '}
          <a
            href="https://www.getdoublenickel.com/terms-of-service"
            className="text-doubleNickel-brand-500 hover:underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of Service
          </a>{' '}
          and{' '}
          <a
            href="https://www.getdoublenickel.com/privacy-policy"
            className="text-doubleNickel-brand-500 hover:underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
          . <span className="text-red-500">*</span>
        </>
      }
      {...props}
    />
  )
}

export default TermsAndPrivacyCheckbox
